import { UxModal, UxAction, UxPriorityEnum, UxStyleEnum } from "@imaginelearning/mps-ux-component-library";
import { useTranslation } from "react-i18next";

interface ILinkLaunchErrorModalProps {
  handleModalClose: () => void;
  title: string;
  message: string;
}

function LinkLaunchErrorModal(props: ILinkLaunchErrorModalProps) {
  const { handleModalClose, title, message } = props;
  const { t } = useTranslation();
  return (
    <UxModal
      showModal={true}
      showClose={false}
      handleClose={() => {
        handleModalClose();
      }}
      title={title}
      backdrop="static"
      body={<span>{message}</span>}
      footer={[
        <UxAction
          key={1}
          enabled={true}
          text={t("Close")}
          priority={UxPriorityEnum.INFO}
          callback={() => {
            handleModalClose();
          }}
          style={UxStyleEnum.ROUNDED}
          className="px-3"
        />,
        <UxAction
          key={0}
          enabled={true}
          text={t("Reload")}
          priority={UxPriorityEnum.SUCCESS}
          callback={() => {
            window.location.reload();
          }}
          style={UxStyleEnum.ROUNDED}
          className="px-3"
        />
      ]}
    />
  );
}

export default LinkLaunchErrorModal;
